import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import uniqueId from 'lodash/uniqueId';
import { Wrapper, ArrowStyled, CurrentStyled } from './CtaDropdown.styles';
import { CtaDropdownProps, Option } from './CtaDropdown.types';
import { OptionsStyled, OptionStyled } from './CtaDropdownDesktop.styles';

export const CtaDropdownDesktop: React.FC<CtaDropdownProps> = ({
  className,
  onSelectCallback,
  options,
  asSelect,
  defaultValue,
}) => {
  const { t, lang } = useTranslation('common');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);

  const idDropdown = 'cta-dropdown_' + uniqueId();

  function switchOpen() {
    setIsOpen((prevState) => !prevState);
  }

  function onClickOutsideEvent(event: { target: any }): void {
    if (!event.target.getAttribute('data-dropdown-id')) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    const preselectedOption = options.find((option) => option.value === defaultValue);

    if (preselectedOption) {
      setSelectedOption(preselectedOption);
    }

    document.addEventListener('click', onClickOutsideEvent);

    const optionsEl = document.getElementById(idDropdown);
    if (optionsEl) {
      optionsEl.addEventListener('mouseleave', () => {
        setIsOpen(false);
      });
    }
    return () => {
      document.removeEventListener('click', onClickOutsideEvent);
    };
  }, [defaultValue]);

  useEffect(() => {
    const preselectedOption = options.find((option) => option.value === defaultValue);

    if (preselectedOption) {
      setSelectedOption(preselectedOption);
    }
  }, [lang]);

  return (
    <Wrapper asSelect={asSelect} className={className} id={idDropdown}>
      <CurrentStyled
        asSelect={asSelect}
        onClick={switchOpen}
        data-dropdown-id="cta-dropdown_current"
      >
        {selectedOption ? selectedOption.label : t('sortByOptionDefault')}
        <ArrowStyled onClick={switchOpen} isOpen={isOpen} />
      </CurrentStyled>

      <OptionsStyled isOpen={isOpen}>
        {options &&
          options.map((option) => {
            return (
              <OptionStyled
                key={`cta-option-${option.label}`}
                onClick={() => {
                  setIsOpen(false);
                  setSelectedOption(option);
                  onSelectCallback(option.value);
                }}
              >
                {option.label}
              </OptionStyled>
            );
          })}
      </OptionsStyled>
    </Wrapper>
  );
};
